import {
  CaptureScheduleRequest,
  convertModalDataToCaptureSchedules,
} from '../../utils/calculate-capture-schedules';
import { SenseiApi } from '../../utils/api';

import {
  CaptureScheduleModalActionTypes,
  CaptureScheduleModalState,
  Status,
} from '../../types/capture-schedule-modal';

import { CaptureScheduleModalSensor } from '../../components/CaptureScheduleModal';

// When the capture schedule modal is submitted, create a bunch of capture schedules based on the state in the modal.
export default async function captureScheduleModalSubmit(
  dispatch,
  modalState: CaptureScheduleModalState,
  sensors: Array<CaptureScheduleModalSensor>,
  jwtToken: string,
) {
  const captureScheduleRequestMetadata = convertModalDataToCaptureSchedules(
    modalState,
    sensors,
  );

  dispatch({
    type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_FINAL_REQUEST_STATUS,
    status: Status.LOADING,
  });

  const captureScheduleRequestsGroupedByOrganization: {
    [organizationId: string]: Array<CaptureScheduleRequest>;
  } = {};
  for (const requestMetadata of captureScheduleRequestMetadata) {
    if (
      !captureScheduleRequestsGroupedByOrganization[
        requestMetadata.organizationId
      ]
    ) {
      captureScheduleRequestsGroupedByOrganization[
        requestMetadata.organizationId
      ] = [];
    }
    captureScheduleRequestsGroupedByOrganization[
      requestMetadata.organizationId
    ].push(requestMetadata);
  }

  const requests = Object.entries(
    captureScheduleRequestsGroupedByOrganization,
  ).map(([organizationId, requestsMetadata]) =>
    SenseiApi.createCaptureSchedules(
      jwtToken,
      organizationId,
      requestsMetadata,
    ),
  );

  try {
    await Promise.all(requests);
  } catch (error) {
    dispatch({
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_FINAL_REQUEST_STATUS,
      status: Status.ERROR,
      error,
    });
    return;
  }

  dispatch({
    type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_FINAL_REQUEST_STATUS,
    status: Status.COMPLETE,
  });
}
